import { render, staticRenderFns } from "./TranslationsAdminPage.vue?vue&type=template&id=7cf4c832"
import script from "./TranslationsAdminPage.vue?vue&type=script&lang=js"
export * from "./TranslationsAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports